/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { EntityTenantSettingsLinks } from '../../../../Services/tenant-settings';
import { SETTING_LIST_LINK_NEXT, SettingListLink } from '../../SettingList.types';

/**
 * Extract a page token string from a settings response link.
 */
export const getPageToken = (links: EntityTenantSettingsLinks, linkType: SettingListLink): string | undefined => {
  const link: string | null = links[linkType];
  if (link === null) {
    return;
  }

  let param: string;
  if (linkType === SETTING_LIST_LINK_NEXT) {
    param = 'page[after]';
  } else {
    param = 'page[before]';
  }

  const queryString = link.split('?')[1];
  const queryParams = queryString.split('&');
  const pageComponent = queryParams.filter((item) => item.indexOf(param) !== -1);

  if (pageComponent.length) {
    return pageComponent[0].split(`${param}=`)[1];
  }

  return;
};
